import { create } from 'lodash';
import { bool } from 'prop-types';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface ShowUploadDropZoneCtx {
  showUploadZone: boolean;
  setShowUploadZone: Dispatch<
    SetStateAction<ShowUploadDropZoneCtx['showUploadZone']>
  >;
}

const ShowUploadDropZoneContext = createContext({
  showUploadZone: false,
  setShowUploadZone: () => false,
} as ShowUploadDropZoneCtx);

export default ShowUploadDropZoneContext;
